export default "__VITE_ASSET__PMpF1Xqe__"